import { create } from 'zustand';

import { i18n } from '@/i18n/instance';

interface LocaleState {
  locale: string;
  setLocale: (locale: string) => void;
}

const useLocaleStore = create<LocaleState>((set) => ({
  locale: i18n.getLocale(),
  setLocale: (locale) => {
    i18n.setLocale(locale);
    set({ locale: i18n.getLocale() });
  },
}));

export { useLocaleStore };
